<template>
    <div class="content">
        <Header :fr="fromSource"></Header>
        <BrowserAlert></BrowserAlert>
        <div class="bottom">
            <!-- <div class="top" v-if="fromSource !== 'aihome'">
                <select-area :selecting="selecting" @change-select="changeSelect" :total="total"></select-area>
            </div> -->
            <div class="right">
                <span class="big-title">
                    <!-- {{(selecting==0 ? '我创建的面试' : selecting == 2 ? '全部公司面试' : selecting == 3 ? '我参与的面试' : '排队面试') + ' (' + total + ')'}} -->
                    <select-area :selecting="selecting" @change-select="changeSelect" :total="total"></select-area>
                </span>
                <div>
                    <el-button v-if="selecting !== 4" type="primary" @click="plCreate" size="small" style="font-size: 14px;">批量创建面试</el-button>
                    <el-button v-if="selecting !== 4" type="primary" @click="newInterview(1)" style="margin-left: 20px;font-size: 14px;" size="small">新建视频面试</el-button>
                    <!-- <el-button v-if="selecting !== 4" type="primary" @click="newInterview(0)" style="margin-left: 20px;">新建单人视频面试</el-button>  -->
                    <span class="btn-text" v-if="selecting === 4" @click="toHelp" style="font-size: 14px;">如何使用排队面试？</span>
                    <el-button v-if="selecting === 4" type="primary" @click="plCreateQueue" size="small" style="font-size: 14px;">批量创建排队面试</el-button>
                    <el-button v-if="selecting === 4" type="primary" @click="newQueueInterview()" style="margin-left: 20px;font-size: 14px;" size="small">新建排队面试</el-button>
                </div>
            </div>
            <div class="search" v-if="showSelect">
                <div class="select">
                    <span style="font-size: 14px;margin: 0 20px;margin-right: 10px;font-weight:400;color:rgba(139,143,148,1);">面试时间</span>
                    <el-date-picker
                        style="width:280px"
                        v-model="dateRange"
                        type="daterange"
                        align="right"
                        unlink-panels
                        size="small"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="getList"
                        :default-time="defaultTime"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                    <div style="display:inline-flex;align-items:center" v-if="selecting == 0 || selecting == 2 || selecting == 3">
                        <span style="font-size: 14px;margin: 0 10px; margin-left: 20px;font-weight:400;color:rgba(139,143,148,1);">状态</span>
                        <el-select v-model="interviewStatus" clearable @change="getList" size="small" style="width:100px">
                            <el-option label="正常" value="3"></el-option>
                            <el-option label="已结束" value="4"></el-option>
                            <el-option label="已取消" value="1"></el-option>
                        </el-select>
                        <el-input v-model="searchCName" placeholder="候选人姓名" size="small" style="width: 150px;margin-left:10px" clearable @change="getList"></el-input>
                        <el-input v-model="searchIName" placeholder="面试官姓名" size="small" style="width: 150px;margin-left:10px" clearable @change="getList"></el-input>
                        <el-button type="primary" size="small" @click="getList" style="margin-left:10px;background: #3E444C;border: #3E444C;">搜索</el-button>
                    </div>
                    <!-- <el-button style="margin-left: 20px" type="primary" size="small" @click="changeSortMethod">{{sortByBeginTime?'按创建时间排序':'按面试时间排序'}}</el-button> -->
                </div>
                <div class="result">
                    <div>{{total}}个结果</div>
                    <img src="/static/img/output.png" style="width: 14px;margin-left: 20px;margin-right: 5px;"  v-if="selecting!==4"/>
                    <el-tooltip v-if="selecting!==4" class="item" content="将现有筛选条件下的全部面试信息导出到excel" placement="bottom">
                        <el-button type="text" @click="exportInterview">导出</el-button> 
                    </el-tooltip>
                </div>
            </div>
            <div class="table">
                <el-table :data="list" :header-row-style="rowStyle" :show-header="list.length != 0" @sort-change="changeSortMethod" :row-class-name="tableRowClassName">
                    <el-table-column
                        key="1"
                        label="基本信息">
                        <template slot-scope="scope">
                            <div style="text-align: left;" class="info-box">
                                <p class="single-info"><span class="left">公司：</span><span style="margin-left: 13px">{{scope.row.companyName}}</span></p>
                                <p class="single-info"><span class="left">职位：</span> <span style="margin-left: 13px">{{scope.row.positionName}}</span></p>
                                <p class="single-info" v-if="selecting != 4 && scope.row.isMutiInterview == 0">
                                    <span class="left">候选人：</span> 
                                    <span>{{scope.row.candidateName}}</span>
                                </p>
                                <div class="name-info" v-if="selecting != 4 && scope.row.isMutiInterview == 1">
                                    <span class="left">候选人：</span> 
                                    <div class="name">
                                        <span v-for="(item, index) in scope.row.memberList && scope.row.memberList.filter(e => e.role == 0)">{{item.showName}}</span>
                                    </div>
                                </div>
                                <span class="link" v-if="scope.row.candidateCvId && scope.row.candidateCvId != '0'" @click="toCv(scope.row.candidateCvId)">查看简历</span>
                                <span class="link" v-else-if="scope.row.attachmentUrl" @click="jumpAttach(scope.row.attachmentUrl)">查看简历</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        key="2"
                        v-if="selecting === 2"
                        prop="userPhone"
                        label="创建人账号">
                    </el-table-column>
                    <!-- <el-table-column
                        key="3"
                        v-if="selecting !== 4"
                        label="简历">
                        <template slot-scope="scope">
                            <span class="link" v-if="scope.row.candidateCvId != '0'" @click="toCv(scope.row.candidateCvId)">查看详情</span>
                            <span class="link" v-else-if="scope.row.attachmentUrl" @click="jumpAttach(scope.row.attachmentUrl)">查看详情</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column
                        key="4"
                        sortable="custom"
                        label="视频面试时间">
                        <template slot-scope="scope">
                            <span v-if="selecting != 4">{{scope.row.interviewBeginTime && scope.row.interviewBeginTime.substring(0, 16)}}</span>
                            <span v-else>{{scope.row.beginTime?scope.row.beginTime.substring(0, 16):''}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="面试类型" v-if="selecting !== 4" key="5">
                        <template slot-scope="scope">{{scope.row.isMutiInterview ? '多人' : '单人'}}</template>
                    </el-table-column> -->
                    <el-table-column
                        key="6"
                        label="面试官接入" 
                        
                        class = "table-item"
                        >
                        <template slot-scope="scope">
                            <div style="text-align:left" v-if="selecting != 4">
                                <p style="margin-bottom:5px">接入码：{{scope.row.interviewerConnectCode}}</p>
                                <p class="link small" @click="toInterview(scope.row.interviewerUrl)" v-if="selecting !== 4" style="color:#27BA9C;margin-bottom:5px">进入面试</p>
                                <span class="link small" @click="toInterview(scope.row.interviewerUrl)" v-else style="color:#27BA9C">进入面试</span>
                                <span class="link small" style="margin-right: 6px" @click="copyLink(scope.row.interviewerUrl);log('clickCopyLink',`点击列表页中面试官接入的“复制链接”`)">复制链接</span>
                                <span class="link small" @click="copyNotify(scope.row, 0);log('clickCopyLink',`点击列表页中面试官接入的“复制通知”`)">复制通知</span>
                                <p v-for="item in scope.row.memberList.filter(e => e.role == 1)" v-show="item.phone || item.showName" style="margin-top:5px">{{item.showName}} {{item.phone}}</p>
                            </div>
                            <div v-else>
                                <p style="margin-bottom:5px">面试官 {{scope.row.interviewerCount?scope.row.interviewerCount.all:0}} 位</p>
                                <p class="grey-word" style="margin-bottom:5px">空闲面试官 {{scope.row.interviewerCount?scope.row.interviewerCount.inQueue:0}} 位</p>
                                <p class="grey-word" style="margin-bottom:5px">正在面试中 {{scope.row.interviewerCount?scope.row.interviewerCount.inInterview:0}} 位</p>
                                <p class="link small" @click="toEditQueue(scope.row)">面试官详情</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        key="7"
                        label="候选人接入" 
                        
                        class = "table-item"
                        >
                        <template slot-scope="scope">
                            <div style="text-align:left" v-if="selecting != 4">
                                <p style="margin-bottom:5px">接入码：{{scope.row.candidateConnectCode}}</p>
                                <p class="link small" @click="toInterview(scope.row.candidateUrl)" v-if="selecting !== 4" style="color:#27BA9C;margin-bottom:5px">进入面试</p>
                                <span class="link small" @click="toInterview(scope.row.candidateUrl)" v-else style="color:#27BA9C">进入面试</span>
                                <span class="link small" style="margin-right: 6px" @click="copyLink(scope.row.candidateUrl);log('clickCopyLink',`点击列表页中面试官接入的“复制链接”`)">复制链接</span>
                                <span class="link small" @click="copyNotify(scope.row, 1);log('clickCopyLink',`点击列表页中候选人接入的“复制通知”`)">复制通知</span>
                                <p v-for="(item, index) in scope.row.memberList.filter(e => e.role == 0)" :key="index" v-show="item.phone" style="margin-top:5px">{{item.showName}} {{item.phone}}</p>
                            </div>
                            <div v-else>
                                <p style="margin-bottom:5px">候选人 {{scope.row.candidateCount?scope.row.candidateCount.all:0}} 位</p>
                                <p class="grey-word" style="margin-bottom:5px">排队中 {{scope.row.candidateCount?scope.row.candidateCount.inQueue:0}} 位</p>
                                <p class="grey-word" style="margin-bottom:5px">已面试 {{scope.row.candidateCount?scope.row.candidateCount.afterInterview:0}} 位</p>
                                <p class="link small" @click="toEditQueue(scope.row)">候选人详情</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        key="8"
                        v-if="selecting !== 4"
                        prop="record_url_list"
                        label="回放">
                        <template slot-scope="scope">
                            <div v-if="scope.row.recordUrlList && scope.row.recordUrlList.length" @click="toVideo(scope.row)">
                                <div class="link small" style="color: rgb(39, 186, 156)">查看回放</div>
                                <div style="color: #8B8F94;margin-top: 5px">{{`时长: ${calTime(scope.row.bothJoinSecond)}`}}</div>
                            </div>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        key="9"
                        
                        label="状态">
                        <template slot-scope="scope">
                            <div v-if="selecting != 4">
                                <div v-if="scope.row.interviewStatus == '正常'">
                                    <p  style="margin-bottom:5px" class="exit" :class="{ enter: scope.row.candidateOnline !== 0 }">{{scope.row.candidateOnline == 0 ? '候选人未进入' : '候选人已进入'}}</p>
                                    <p class="exit" :class="{ enter: scope.row.interviewerOnline !== 0 }">{{scope.row.interviewerOnline == 0 ? '面试官未进入' : '面试官已进入'}}</p>
                                </div>
                                <div v-else>{{scope.row.interviewStatus}}</div>
                            </div>
                            <div v-else>
                                <span v-if="scope.row.interviewStatus===0">正常</span>
                                <span v-if="scope.row.interviewStatus===1">已取消</span>
                                <span v-if="scope.row.interviewStatus===3">已结束</span>
                                <div style="margin-top:5px" class="link small" v-if="scope.row.interviewStatus===0" @click="jumpQueue(scope.row.queueInterviewId)">查看排队情况</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        key="10"
                        width="150px"
                        v-if="selecting !== 3"
                        label="操作">
                        <template slot-scope="{row}" v-if="row.userId == user.id || selecting === 4">
                            <div style="display: flex;margin-bottom: -10px;margin-top: -9px;">
                                <el-button type="text" @click="cancel(row)" v-if="row.interviewStatus == '正常' || (row.interviewStatus == 0 && selecting == 4)">取消</el-button>
                                <el-button type="text" @click="editTime(row)" v-if="row.interviewStatus == '正常' && selecting !== 4">编辑面试</el-button>
                                <el-button type="text" @click="del(row)">删除</el-button>
                            </div>
                            <el-button type="text" @click="finishInterview(row)" v-if="row.interviewStatus == '正常' && selecting !== 4">结束面试</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="selecting!=4"
                        
                        label="备注">
                        <template slot-scope="scope">
                            <div style="text-align:left;">
                                <img src="/static/img/edit-remark.png" style="width:14px;height:13px;cursor: pointer;" @click="openRemark(scope.row)"/>
                                <p class="limit">{{scope.row.remark}}</p>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page">
                <el-pagination
                        background
                        :current-page.sync="currentPage"
                        @current-change="getList"
                        layout="prev, pager, next"
                        :total="total"
                        style="margin-bottom: 10px">
                </el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="showModal" :title="form.id?`编辑视频面试`:`创建视频面试`" custom-class="dialog" :width="form.isMutiInterview?'650px':'520px'" :close-on-click-modal="false">
            <el-form ref="form" size="small" :model="form" :rules="rules" label-width="90px" label-position="left">
                 <el-form-item label="面试时间" required class="timepicker">
                    <el-col :span="11">
                    <el-form-item prop="date1">
                        <el-date-picker :picker-options='pickerBeginDateBefore'  type="date" size="small" placeholder="选择日期" v-model="form.date1" style="width: 100%;" @blur="$forceUpdate()"></el-date-picker>
                    </el-form-item>
                    </el-col>
                    <el-col class="line" :span="2">-</el-col>
                    <el-col :span="11">
                    <el-form-item prop="date2">
                        <el-time-picker
                            v-model="form.date2"
                            format='HH:mm'
                            value-format="HH:mm"
                            style="width: 100%;"
                            @focus="$forceUpdate()"
                            placeholder="选择时间">
                        </el-time-picker>
                    </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label="公司名称">
                    <!-- <auto-input @select="handleSelect" formName="createInterviewForm" propName="companyName" clearable placeholder="公司/团队名称" @input="$forceUpdate()" size="small" v-model="form.companyName" style="width:100%"></auto-input> -->
                    <el-input placeholder="公司/团队名称" @input="$forceUpdate()" size="small" v-model="form.companyName"></el-input>
                </el-form-item>
                <el-form-item label="应聘职位名称">
                    <!-- <auto-input @select="handleSelect" formName="createInterviewForm" propName="positionName" placeholder="职位名称，如开发工程师" @input="$forceUpdate()" size="small" v-model="form.positionName" style="width:100%"></auto-input> -->
                    <el-input placeholder="职位名称，如开发工程师" @input="$forceUpdate()" size="small" v-model="form.positionName"></el-input>
                </el-form-item>
                <!-- 多人面试 -->
                <div v-if="form.isMutiInterview">
                    <el-form-item label="通知候选人">
                        <div class="single" v-for="(item, index) in candidateMemberList" :key="item.key">
                            <el-form :model="item" inline class="flexRow" size="small" :disabled="Boolean(form.id) && index < CLen">
                                <el-form-item>
                                    <auto-input formName="interviewerInfoForm" propName="showName" @select="handleSelectInfo($event, item)" v-model="item.showName" placeholder="姓 名"></auto-input>
                                </el-form-item>
                                <el-form-item>
                                    <auto-input formName="interviewerInfoForm" propName="phone" @select="handleSelectInfo($event, item)" v-model="item.phone" placeholder="手 机 号"></auto-input>
                                </el-form-item>
                                <el-form-item>
                                    <auto-input formName="interviewerInfoForm" propName="email" @select="handleSelectInfo($event, item)" v-model="item.email" placeholder="邮 箱"></auto-input>
                                </el-form-item>
                                <el-form-item><i class="el-icon-circle-close hoverPrimary" v-if="!(Boolean(form.id) && index < CLen)" @click="delMember('0',index)"></i></el-form-item>
                            </el-form>
                        </div>
                        <el-button type="text" size="mini" @click="addMember('0')">增加</el-button>
                    </el-form-item>
                    <el-form-item label="通知面试官">
                        <div class="single" v-for="(item, index) in interviewerMemberList" :key="item.key">
                            <el-form :model="item" inline class="flexRow" size="small" :disabled="Boolean(form.id) && index < ILen">
                                <el-form-item>
                                    <auto-input formName="interviewerInfoForm" propName="showName" @select="handleSelectInfo($event, item)" v-model="item.showName" placeholder="姓 名"></auto-input>
                                </el-form-item>
                                <el-form-item>
                                    <auto-input formName="interviewerInfoForm" propName="phone" @select="handleSelectInfo($event, item)" v-model="item.phone" placeholder="手 机 号"></auto-input>
                                </el-form-item>
                                <el-form-item>
                                    <auto-input formName="interviewerInfoForm" propName="email" @select="handleSelectInfo($event, item)" v-model="item.email" placeholder="邮 箱"></auto-input>
                                </el-form-item>
                                <el-form-item><i class="el-icon-circle-close hoverPrimary" v-if="!(Boolean(form.id) && index < ILen)" @click="delMember('1',index)"></i></el-form-item>
                            </el-form>
                        </div>
                        <el-button type="text" size="mini" @click="addMember('1')">增加</el-button>
                    </el-form-item>
                </div>
                <!-- 单人面试 -->
                <div v-else>
                    <el-form-item label="候选人姓名" prop="name">
                        <el-input placeholder="姓名" @input="$forceUpdate()" size="small"  :disabled="Boolean(form.id)" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="通知候选人">
                        <el-checkbox :disabled="Boolean(form.id)" @input="$forceUpdate()" @change="changeNotify($event, 0)" v-model="form.notifyCandidate">发送短信和邮件通知</el-checkbox>
                    </el-form-item>
                    <div class="right-form" v-if="form.notifyCandidate">
                        <el-form-item label="候选人手机号">
                            <el-input placeholder="手机号" :disabled="Boolean(form.id)" @input="$forceUpdate()" size="small" v-model="form.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="候选人邮箱">
                            <el-input placeholder="邮箱" :disabled="Boolean(form.id)" @input="$forceUpdate()" size="small" v-model="form.email"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item label="通知面试官">
                        <el-checkbox :disabled="Boolean(form.id)" @input="$forceUpdate()" @change="changeNotify($event, 1)" v-model="form.notifyInterviewer">发送短信和邮件通知</el-checkbox>
                    </el-form-item>
                    <div class="right-form" v-if="form.notifyInterviewer">
                        <el-form-item label="面试官手机号">
                            <el-input :disabled="Boolean(form.id)" placeholder="手机号" @input="$forceUpdate()" size="small" v-model="form.myPhone"></el-input>
                        </el-form-item>
                        <el-form-item label="面试官邮箱">
                            <el-input :disabled="Boolean(form.id)" placeholder="邮箱" @input="$forceUpdate()" size="small" v-model="form.myEmail"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <el-form-item label="面试过程录制">
                    <el-switch v-model="form.record" @change="$forceUpdate()"></el-switch>
                </el-form-item>
                <el-form-item label="候选人简历">
                    <el-checkbox v-model="isUpload">上传候选人简历</el-checkbox>
                    <CommonUpload 
                        v-if="isUpload"
                        class="common-upload"
                        :before-upload="uploadJud"
                        @upload-success="uploadSuccess"
                    >
                        <el-button size="mini" type="primary">点击上传</el-button>
                        <div slot="tip" class="file">
                            <el-alert
                                @close="remove"
                                v-if="hasFile"
                                :title="attachmentName"
                                type="info">
                            </el-alert>

                        </div>
                    </CommonUpload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="footer">
                <el-button class="cancel" size="small" @click="cancelNew">取消</el-button>
                <el-button type="primary" size="small" :loading="loading" @click="sureEditTime" v-if="form.id">修改</el-button>
                <el-button type="primary" size="small" :loading="loading" @click="create" v-else>创建</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="showCancelModal" title="是否确定取消面试" custom-class="dialog" width="520px">
            <div class="cancel-contents">
                <p class="row">
                    <span class="label">通知候选人</span>
                    <el-checkbox v-model="isNotify">发送短信和邮件通知</el-checkbox>
                </p>
            </div>
            <div slot="footer" class="footer">
                <el-button class="cancel" size="small" @click="showCancelModal = false">取消</el-button>
                <el-button type="primary" size="small" :loading="loading" @click="sureCancel">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="showDelModal" title="提示" custom-class="dialog" width="520px">
            <div class="del-contents">是否确定删除面试？</div>
            <div slot="footer" class="footer">
                <el-button class="cancel" size="small" @click="showDelModal = false">取消</el-button>
                <el-button type="primary" size="small" :loading="loading" @click="sureDel">确定</el-button>
            </div>
        </el-dialog>
        <AddRemark
            :visible.sync="showReModal"
            :remarkInfo="reRow"
            isNew
            :connectCode="remarkCode"
            @close="showReModal = false,remarkCode = ''"
            @success="getList"
        ></AddRemark>
        <multi-create-interview 
            :visible.sync="showPlCreateModal" 
            title="批量创建面试"
            @chose="showPlCreateModal = false"
            @refresh="getList"
        ></multi-create-interview>
        <multi-create-queue-interview 
            :visible.sync="showPlCreateQueueModal" 
            title="批量创建排队面试"
            @chose="showPlCreateQueueModal = false"
            @refresh="getList"
        ></multi-create-queue-interview>
    </div>
</template>

<script>
    import merge from 'webpack-merge'
    import toolkit from '@/util/toolkit'
    import config from '@/util/config'
    import Header from '@/components/AiHeader'
    import {mapState} from 'vuex'
    import BrowserAlert from "@/components/BrowserAlert"
    import SelectArea from "@/components/SelectArea"
    import moment from "moment"
    import MultiCreateInterview from "@/components/MultiCreateInterview"
    import MultiCreateQueueInterview from "@/components/MultiCreateQueueInterview"
    import FileJs from "@/util/file"
    import AutoInput from "@/components/AutoInput.vue"
    import CommonUpload from "@/components/CommonUpload"
    import AddRemark from "@/components/AddRemark"
    const CANDIDATE_ROLE = '0'
    const INTERVIEWER_ROLE = '1'
    export default {
        components: {
            Header,
            BrowserAlert,
            SelectArea,
            MultiCreateInterview,
            MultiCreateQueueInterview,
            AutoInput,
            CommonUpload,
            AddRemark
        },
        data(){
            var hasOne = (rule, value, callback) => {
                if(value){
                    callback()
                }else{
                    if(this.notify.email || this.notify.mobile){
                        callback()
                    }else{
                        callback(new Error('手机和邮箱至少填写一项'))
                    }
                }
            }
            return{
                helpUrl: config.noticeUrl,
                pickerBeginDateBefore: {
                    disabledDate(time){
                        return time.getTime() < Date.now()  -8.64e7  //如果当天可选，就不用减8.64e7
                    }
                },
                rowStyle: {
                    color: '#8B8F94',
                    'font-weight': '400',
                    'font-size': '14px',
                    'border-bottom': 'solid 1px #eff2ff'
                },
                currentPage: 1,
                userId: 0,
                dateRange: "",
                interviewStatus: '',
                searchCName: '',
                searchIName: '',
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                defaultTime: ['00:00:01', '23:59:59'],
                showModal: false,// 创建面试弹窗
                showCancelModal: false,// 确认取消面试弹窗
                showDelModal: false, // 删除面试弹窗
                showReModal: false, // 修改备注弹窗
                reRow: {}, // 修改备注行
                editing: {},
                fileList: [],
                remark: '',
                user: {},
                form: {
                    notifyInterviewer: false,
                    notifyCandidate: false
                },
                candidateMemberList: [{
                    role: '0',
                    showName: '',
                    phone: '',
                    email: ''
                }],
                interviewerMemberList: [{
                    role: '1',
                    showName: '',
                    phone: '',
                    email: ''
                }],
                rules: {
                    time: [{required: true, message: '请选择面试时间', trigger: 'change'}],
                    date1: [
                        { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
                    ],
                    date2: [
                        { required: true, message: '请选择时间', trigger: 'change' }
                    ],
                },
                isNotify: false,
                notify: {},
                notifyRules: {
                    mobiles: [{validator: hasOne, trigger: 'change'}],
                    emails: [{validator: hasOne, trigger: 'change'}]
                },
                list: [],
                total: 0,
                loading: false, // loading
                loadingTable: false, // loading table
                selecting: 0,
                ids: [],
                companyName: '', // 公司名，查询用字段

                storageName: ['companyName', 'myPhone', 'myEmail', 'positionName', 'notifyCandidate', 'notifyInterviewer'],
                storageValue: {},
                sortByBeginTime: false,
                attachmentName: '',  //附件
                attachmentUrl: '',
                isUpload: false , //上传附件开关
                autoWidth: 0,
                hasFile: false,
                showPlCreateModal: false,
                showPlCreateQueueModal: false,
                CLen: 0,
                ILen: 0,
                oldDate1: '',
                oldDate2: '',
                hasLoad: false,
                hasLoad1: false,
                showSelect: true,
                remarkCode: "",
                fromSource: ""
            }
        },
        mounted(){
            // 判断是否从AI面试官网过来的用户
            this.fromSource = this.$route.query.fr
            // AI视频面试官网登录判断
            let fromSource = this.$route.query.fr
            if (fromSource === 'aihome') {
                this.$router.push('/exam/paper?back=7&fr=aihome')
            }
            this.user = this.userInfo
            this.companyName = this.user && this.user.companyName
            // 从本地存储里取值
            this.sortByBeginTime = 
                (window.localStorage.getItem("vi-list-sortByBeginTime") || 'false') 
                === 'true' ? 
                true : 
                false

            if(this.$route.query.back){
                this.changeSelect(Number(this.$route.query.back))
            }else{
                this.getList()
            }
        },
        created() {
            let width = (document.body.clientWidth - 200 - 3*80 - 140 - 120 - 160) / 3
            this.autoWidth = (width > 180) ? 180 : width
        },
        computed: {
            ...mapState(['userInfo', 'company']),
        },
        methods:{
            tableRowClassName(row) {
                if(row.row.interviewStatus===3 || row.row.interviewStatus == '已结束') {
                    return 'end-row'
                }
            },
            handleSelect(item){
                for(let prop in item.form){
                    this.form[prop] = item.form[prop]
                }
            },
            handleSelectInfo(item, form){
                for(let prop in item.form){
                    form[prop] = item.form[prop]
                }
            },
            finishInterview(row) {
                this.$confirm('结束面试后无法继续进行面试，是否确定结束面试', '提示').then(res => {
                    let myDate = new Date()
                    let date = myDate.getFullYear() + '-' + 
                        ((myDate.getMonth() + 1) >= 10 ? (myDate.getMonth() + 1) : '0' + ((myDate.getMonth() + 1))) + '-' + 
                        (myDate.getDate() >= 10 ? myDate.getDate() : '0' + myDate.getDate())
                    let time = (myDate.getHours() >= 10 ? myDate.getHours() : '0' + myDate.getHours()) + ':' +
                        (myDate.getMinutes() >= 10 ? myDate.getMinutes() : '0' + myDate.getMinutes()) + ':' +
                        (myDate.getSeconds() >= 10 ? myDate.getSeconds() : '0' + myDate.getSeconds())
                    let par = {
                        interviewId: row.interviewId,
                        endTime: date + ' ' + time,
                        closeMessage: 1
                    }
                    toolkit.post('/interview/video/update', par).then(res => {
                        if(res.code == 0){
                            this.$message.success('结束成功')
                            this.getList()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                })
            },
            calTime(time) {
                let h = parseInt(time / 3600)
                time = time % 3600
                let m = parseInt(time / 60)
                let s = time % 60
                let res = ''
                h && (res += h + '小时')
                res += res ? m + '分' : m ? m + '分' : ''
                res += s + '秒'
                return res
            },
            jumpQueue(id){
                this.$router.push('/queue-status?id=' + id)
            },
            getList(){
                this.loadingTable = true
                this.list = []
                this.remarkCode = ""
                let params = {
                    page: this.currentPage,
                    userId: this.user.id,
                }
                this.dateRange && (params.searchTimeStart = this.dateRange[0])
                this.dateRange && (params.searchTimeStop = this.dateRange[1])
                if(this.ids.length){
                    params.userIdList = this.ids
                }
                if(this.selecting == 2){ // 查公司
                    params.asCompany = 1
                }
                if(this.selecting == 3){
                    params.asMember = 1
                }
                params.sortKey = "begin_time"
                params.sortDict = this.sortByBeginTime ? "asc": "desc"
                if(this.selecting == 4){
                    toolkit.post('/interview/queueVideo/list', params).then(res => {
                        if(res.code == 0){
                            this.list = res.data.list
                            if(!this.hasLoad) {
                                this.hasLoad = true
                                if(this.list.length == 0) {
                                    this.showSelect = false
                                }
                            }
                            this.total = Number(res.data.count)
                            this.log('loadList',`加载列表页，页数：${this.currentPage}`)
                        }else{
                            this.$message.error(res.message)
                        }
                    }).finally(()=>{
                        this.loadingTable = false
                    })
                } else {
                    params.candidateName = this.searchCName
                    params.interviewerName = this.searchIName
                    this.interviewStatus && (params.searchStatus = [this.interviewStatus])
                    toolkit.post('/interview/video/listNew', params).then(res => {
                        if(res.code == 0){
                            this.list = res.data.list
                            if(!this.hasLoad1) {
                                this.hasLoad1 = true
                                if(this.list.length == 0) {
                                    this.showSelect = false
                                }
                            }
                            this.total = Number(res.data.count)
                            this.log('loadList',`加载列表页，页数：${this.currentPage}`)
                        }else{
                            this.$message.error(res.message)
                        }
                    }).finally(()=>{
                        this.loadingTable = false
                    })
                }
            },
            changeSelect(type){
                this.showSelect = true
                this.hasLoad = false
                this.hasLoad1 = false
                this.selecting = type
                this.currentPage = 1
                this.partner = ''
                this.dateRange = ''
                this.interviewStatus = ''
                this.searchCName = ''
                this.searchIName = ''
                if(type === 0){
                    let width = (document.body.clientWidth - 200 - 3*80 - 140 - 120 - 160) / 3
                    this.autoWidth = (width > 180) ? 180 : width
                    this.ids = []
                    this.getList()
                    this.$router.push({
                        query:merge(this.$route.query,{'back':'0'})
                    })
                }else if(type === 1){
                    this.selectPartner()
                }else if(type === 2){
                    this.getList()
                    this.$router.push({
                        query:merge(this.$route.query,{'back':'2'})
                    })
                }else if(type === 3){
                    this.getList()
                    this.$router.push({
                        query:merge(this.$route.query,{'back':'3'})
                    })
                }else if(type === 4){
                    this.log('clickQueueInterview',`点击视频面试列表页“排队面试”`)
                    // 获取排队面试列表
                    this.autoWidth = (document.body.clientWidth - 160 -100) / 5
                    this.getList()
                    this.$router.push({
                        query:merge(this.$route.query,{'back':'4'})
                    })
                }else if(type == 5){
                    this.log('clickKongxuan',`点击视频面试列表页“空中宣讲”`)
                    this.$router.push({
                        name: 'kxlist',
                        query: merge(this.$route.query,{'back':'5'})
                    })
                }else if(type == 6){
                    this.log('clickAiInterview',`点击视频面试列表页“Ai视频面试”`)
                    this.$router.push({
                        name: 'ailist',
                        query: merge(this.$route.query,{'back':'6'})
                    })
                }
                else if(type == 7){
                    this.log('clickBishi',`点击视频面试列表页“在线笔试”`)
                    this.$router.push({
                        name: 'exam-paper',
                        query: merge(this.$route.query,{'back':'7'})
                    })
                }else if(type == 8){
                    this.log('clickQunmian',`点击视频面试列表页“多候选人群面”`)
                    this.$router.push({
                        name: 'group-list',
                        query: merge(this.$route.query,{'back':'8'})
                    })
                }
            },
            newInterview(isMulti){
                this.CLen = 0
                this.ILen = 0
                this.candidateMemberList = [{
                    role: '0',
                    showName: '',
                    phone: '',
                    email: ''
                }],
                this.interviewerMemberList = [{
                    role: '1',
                    showName: '',
                    phone: '',
                    email: ''
                }]
                this.getStorageValue()
                this.form = {
                    record: true,
                    date1: moment().add(1, 'd').toDate(),
                    date2: '10:00',
                    isMutiInterview: isMulti
                }
                for(let item in this.storageValue){
                    this.storageValue && (this.form[item] = this.storageValue[item])
                }
                this.showModal = true
                this.log('clickNewInterview',`新建${isMulti? '多人' : ''}视频面试`)
            },
            create(){
                this.log('clickCreateInterview',`点击新建视频面试弹窗中的“创建”按钮`)
                this.$refs['form'].validate(valid => {
                    if(valid){
                        this.submit()
                    }
                })
            },
            cancelNew(){
                this.fileList = []
                this.isUpload = false
                this.showModal = false;
                this.log('clickCancel',`点击新建视频面试弹窗中的“取消”按钮`)
            },
            isEmail(str){
                return (str && str.indexOf("@") > 0) && (str && str.indexOf("@") < str.length - 1)
            },
            makeUpMembers(){
                let members = []
                // 多人面试
                if(this.form.isMutiInterview){
                    let list1 = this.candidateMemberList.slice(this.CLen, this.candidateMemberList.length)
                    let list2 = this.interviewerMemberList.slice(this.ILen, this.interviewerMemberList.length)
                    members = list1.concat(list2)
                // 单人面试
                }else{
                    members = [{
                        role: '0',
                        showName: this.form.name,
                        phone: this.form.phone,
                        email: this.form.email
                    },{
                        role: '1',
                        showName: this.user.nickname || '',
                        phone: this.form.myPhone,
                        email: this.form.myEmail
                    }]
                }
                return members
            },
            submit(){
                let time = toolkit.format(this.form.date1, 'yyyy-MM-dd') + ' ' + this.form.date2 + ':00'
                let timeStamp = toolkit.getTimeStamp(time)
                let members = this.makeUpMembers()
                if(this.form.email && !this.isEmail(this.form.email) || this.form.myEmail && !this.isEmail(this.form.myEmail)){
                    this.$message.error("邮箱格式不正确")
                    return
                }
                let params = {
                    beginTime: time,
                    userId: this.user.id,
                    members: members,
                    companyName: this.form.companyName,
                    positionName: this.form.positionName,
                    closeRecord: this.form.record ? 0 : 1,
                    app_code: 'vi',
                    isMutiInterview: this.form.isMutiInterview,
                    attachmentName: this.isUpload ? this.attachmentName : '',
                    attachmentUrl: this.isUpload ? this.attachmentUrl : ''
                }
                this.loading = true
                // this.afterSubmit(params)
                members.forEach(form => {
                    this.afterSubmitNoticeForm(form)
                })
                toolkit.post('/interview/video/create', params).then(res => {
                    if(res.code == 0){
                        this.$message.success('创建成功')
                        this.showModal = false
                        this.storageFormItems(this.form)
                        this.getList()
                        // this.$refs['form'] && this.$refs['form'].resetFields()
                        this.fileList = []
                        this.hasFile = false
                        this.isUpload = false
                    } else {
                        this.$message.error(res.message)
                    }
                }).finally(err => {
                    this.loading = false
                }).catch(e => {
                    this.showModal = false
                })
            },
            afterSubmit(form){
                this.$store.dispatch("submitForm", {
                    formName: "createInterviewForm", 
                    form,
                    propNames: ["companyName", "positionName"]
                })
            },
            afterSubmitNoticeForm(form){
                this.$store.dispatch("submitForm", {
                    formName: "interviewerInfoForm", 
                    form,
                    propNames: ["showName", "phone", "email"]
                })
            },
            // 缓存字段
            storageFormItems(params){
                let form = {}
                this.storageName.forEach(item => {
                    form[item] = params[item]
                })
                window.localStorage.setItem('cacheForm', JSON.stringify(form))
            },
            getStorageValue(){
                this.storageValue = JSON.parse(window.localStorage.getItem('cacheForm'))
            },
            toVideo(row){
                this.log('clickPlayInterview',`点击列表页中回放的“查看回放”`)
                let id = (row && row.interviewId) || ''
                window.open(`/#/play?interview_id=${id}&app_code=hina&code=${row.interviewerConnectCode}`)
            },
            toInterview(url){
                this.log('clickToInterview',`点击列表页中面试官接入的“进入面试”`)
                window.open(url)
            },
            copyLink(url){
                this.copyUrl(url)
            },
            copyNotify(row, type){
                let text = ''
                if(type == 0){ // 面试官
                    text = 
`已为您安排了一场视频面试。

候选人：${row.candidateName}
职位：${row.positionName}
面试时间：${row.interviewBeginTime}
面试形式：视频面试
视频面试链接：${row.interviewerUrl}
视频面试接入码：${row.interviewerConnectCode}
联系人：${row.userPhone}

请提前30分钟做好网络准备和设备调试，设备调试链接：${config.interviewHost}/#/device-test。`
                }else{ // 候选人
                    text = `
您有一个面试邀请。

公司：${row.companyName}
职位：${row.positionName}
面试时间：${row.interviewBeginTime}
面试形式：视频面试
视频面试链接：${row.candidateUrl}
视频面试接入码：${row.candidateConnectCode}
联系人：${row.userPhone}

请提前30分钟做好网络准备和设备调试，设备调试链接：${config.interviewHost}/#/device-test。

                    `
                }
                this.copyUrl(text)
            },
            toCv(candidateCvId){
                this.log('clickToCv',`点击列表页中简历的“查看详情”`)
                window.open(toolkit.routeToSaas('/#/workflow?cvId='+candidateCvId))
            },
            copyUrl(url){
                let oInput = document.createElement('textarea')
                oInput.value = url
                document.body.appendChild(oInput)
                oInput.select()
                document.execCommand("Copy")
                oInput.style.display = 'none'
                document.body.removeChild(oInput)
                this.$message.success('复制链接成功')
            },
            cancel(item){
                this.notify.mobile = item.candidatePhone
                this.notify.email = item.candidateEmail
                this.showCancelModal = true
                this.editing = item
            },
            sureCancel(){
                let vari = false
                if(this.isNotify && this.selecting!=4){
                    // this.$refs['notify-form'].validate(valid => {
                    //     vari = valid
                    // })    
                    vari = true                
                }else{
                    vari = true
                }
                if(vari){
                    this.loading = true
                    if(this.selecting != 4){
                        toolkit.post('/interview/video/close', {
                            closeMessage: this.isNotify?0:1,
                            interviewId: this.editing.interviewId,
                            phone: this.notify.mobile,
                            email: this.notify.email
                        }).then(res => {
                            if(res.code ==0){
                                this.showCancelModal = false
                                // this.$refs['notify-form'].resetFields()
                                this.editing = {}
                                this.$message.success('取消成功')
                                this.getList()
                            }else{
                                this.$message.error(res.message)
                            }
                        }).finally(()=>{
                            this.loading = false
                        })
                    } else {
                        toolkit.post('/interview/queueVideo/close', {
                            closeMessage: this.isNotify?0:1,
                            queueInterviewId: this.editing.queueInterviewId,
                        }).then(res => {
                            if(res.code ==0){
                                this.getList()
                                this.showCancelModal = false
                                // this.$refs['notify-form'] && this.$refs['notify-form'].resetFields()
                                this.editing = {}
                                this.$message.success('取消成功')
                            }else{
                                this.$message.error(res.message)
                            }
                        }).finally(()=>{
                            this.loading = false
                        })
                    }
                }
            },
            del(item){
                this.showDelModal = true
                this.editing = item
            },
            sureDel(){
                this.loading = true
                if(this.selecting != 4){
                    toolkit.post('/interview/video/delete', {
                        closeMessage: 0,
                        interviewId: this.editing.interviewId
                    }).then(res => {
                        if(res.code ==0){
                            this.showDelModal = false
                            this.editing = {}
                            this.$message.success('删除成功')
                            this.getList()
                        }else{
                            this.$message.error(res.message)
                        }
                    }).finally(()=>{
                        this.loading = false
                    })
                } else {
                    toolkit.post('/interview/queueVideo/delete', {
                        closeMessage: 0,
                        queueInterviewId: this.editing.queueInterviewId
                    }).then(res => {
                        if(res.code ==0){
                            this.showDelModal = false
                            this.editing = {}
                            this.$message.success('删除成功')
                            this.getList()
                        }else{
                            this.$message.error(res.message)
                        }
                    }).finally(()=>{
                        this.loading = false
                    })
                }
            },
            editTime(item){
                // 成员相关字段回显
                if(item.isMutiInterview){
                    this.candidateMemberList = item.memberList.filter(e => e.role == CANDIDATE_ROLE)
                    this.CLen = this.candidateMemberList.length
                    this.interviewerMemberList = item.memberList.filter(e => e.role == INTERVIEWER_ROLE)
                    this.ILen = this.interviewerMemberList.length
                }else{
                    item.name = item.candidateName
                    if(item.candidatePhone){
                        item.phone = item.candidatePhone
                        item.notifyCandidate = true
                    }
                    if(item.candidateEmail){
                        item.email = item.candidateEmail
                        item.notifyCandidate = true
                    }
                    if(item.interviewerPhone){
                        item.myPhone = item.interviewerPhone
                        item.notifyInterviewer = true
                    }
                    if(item.interviewerEmail){
                        item.myEmail = item.interviewerEmail
                        item.notifyInterviewer = true                    
                    }
                }
                this.oldDate1 = item.interviewBeginTime.split(' ')[0]
                this.oldDate2 = item.interviewBeginTime.split(' ')[1].slice(0, -3)
                item.date1 = new Date(this.oldDate1)
                item.date2 = this.oldDate2
                item.id = item.interviewId
                item.record = item.hasRecord
                this.form = item
                this.showModal = true
            },
            sureEditTime(){
                this.$refs['form'].validate(valid => {
                    if(valid){
                        this.editSubmit()
                    }
                })
            },
            editSubmit(){
                this.loading = true
                let time = toolkit.format(this.form.date1, 'yyyy-MM-dd') + ' ' + this.form.date2 + ':00'
                let timeStamp = toolkit.getTimeStamp(time)
                let params = {
                    interviewId: this.form.id,
                    companyName: this.form.companyName,
                    positionName: this.form.positionName,
                    closeRecord: this.form.record ? 0 : 1,
                    attachmentName: this.isUpload ? this.attachmentName : '',
                    attachmentUrl: this.isUpload ? this.attachmentUrl : ''
                }
                if(this.oldDate1 != toolkit.format(this.form.date1, 'yyyy-MM-dd') || this.oldDate2 != this.form.date2){
                    params.beginTime = time
                }
                toolkit.post('/interview/video/update', params).then(res => {
                    if(res.code == 0){
                        // 多人面试增加成员
                        // this.storageFormItems(this.form)
                        if(this.form.isMutiInterview){
                            let par = {
                                interviewId: this.form.id,
                                members: this.makeUpMembers()
                            }
                            toolkit.post('/interview/video/addMember', par).then(res => {
                                if(res.code == 0){
                                    this.$message.success('修改成功')
                                    this.showModal = false
                                    // this.$refs['form'] && this.$refs['form'].resetFields()
                                    this.getList()
                                }else{
                                    this.$message.error(res.message)
                                }
                            })
                        } else {
                            this.$message.success('修改成功')
                            this.showModal = false
                            this.getList()
                            // this.$refs['form'] && this.$refs['form'].resetFields()
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                }).finally(()=>{
                    this.loading = false
                    this.isUpload = false
                    this.hasFile = false
                    this.fileList = []
                })
            },
            changeNotify(show, scence){
                if(scence == 0){ // 勾选通知候选人
                    if(!show){
                        this.form.phone = null
                        this.form.email = null
                    }
                }else{ // 勾选通知面试官
                    if(!show){
                        this.form.myPhone = null
                        this.form.myEmail = null
                    }
                }
            },
            log(action, info, extraData){
                return toolkit.logToBackend(action,info, extraData)
            },
            changeSortMethod(params){            
                if(params.order === "ascending"){
                    this.sortByBeginTime = true
                }else{
                    this.sortByBeginTime = false
                }
                window.localStorage.setItem('vi-list-sortByBeginTime',this.sortByBeginTime)
                this.getList()
            },
            editRemark(){
                this.loading = true
                let params = {
                    connectCode: this.reRow.candidateConnectCode,
                    remark: this.remark
                }
                toolkit.post('/interview/video/updateMember', params).then(res => {
                    if(res.code == 0){
                        this.$message.success('修改成功')
                        this.showReModal = false
                        this.getList()
                    }else{
                        this.$message.error(res.message)
                    }
                }).finally(() => {
                    this.loading = false
                })
            },
            jumpAttach(url) {
                window.open(url)
            },
            uploadJud(file){
                if(file.name && typeof file.name == 'string'){
                    let ext = file.name.split('.')
                    if(ext.length>1){
                        if(file.size > 8 * 1024 *1024) {
                            this.$message.error("文件大小超过8M")
                            return false
                        }
                    } else {
                        this.$message.error("无法识别")
                        return false
                    }
                } else {
                    this.$message.error("无法识别")
                    return false
                }
            },
            uploadSuccess(response){
                this.loading = false
                this.attachmentName = response.filename
                this.attachmentUrl = response.url
                this.hasFile = true
            },
            remove(){
                this.attachmentUrl = ''
                this.attachmentName = ''
                this.hasFile = false
            },
            progress(){
                this.hasFile = true
                this.loading = true
            },
            error(){
                this.hasFile = false
                this.loading = false
            },
            openRemark(row){
                this.reRow = JSON.parse(JSON.stringify(row));
                if (row.remarkJson == "" || row.remarkJson == "[]") {
                    this.remarkCode = this.reRow.candidateConnectCode;
                }
                this.$nextTick(()=>{
                    this.showReModal = true;
                })
            },
            newQueueInterview(){
                //跳去排队面试创建
                this.log('clickNewQueueInterview', `点击新建排队面试按钮`)
                toolkit.confirmAuth().then(() => {
                    this.$router.push('/create-queue')
                })
            },
            toEditQueue(row){
                console.log(row)
                let isClose = row.interviewStatus == 0 ? 0 : 1
                let queueInterviewId = row.queueInterviewId
                this.$router.push(`/create-queue?id=${queueInterviewId}&isClose=${isClose}`)
            },
            toHelp(){
                window.open('http://hinapower.udesk.cn/hc/articles/178731')
            },
            plCreate(){
                this.log('clickPlCreate', `点击批量创建按钮`)
                toolkit.confirmAuth().then(() => {
                    this.showPlCreateModal = true
                })
            },
            plCreateQueue(){
                this.log('clickPlCreateQueue', `点击批量创建排队面试按钮`)
                toolkit.confirmAuth().then(() => {
                    this.showPlCreateQueueModal = true
                })
            },
            // 导出面试
            exportInterview(){
                this.log('clickExportInterview', `点击导出按钮`)
                let params = {
                    userId: this.user.id
                }
                this.dateRange && (params.searchTimeStart = this.dateRange[0])
                this.dateRange && (params.searchTimeStop = this.dateRange[1])
                if(this.ids.length){
                    params.userIdList = this.ids
                }
                if(this.selecting == 2){ // 查公司
                    params.asCompany = 1
                }
                if(this.selecting == 3){
                    params.asMember = 1
                }
                params.sortKey = "begin_time"
                params.sortDict = this.sortByBeginTime ? "asc": "desc"
                params.candidateName = this.searchCName
                params.interviewerName = this.searchIName
                this.interviewStatus && (params.searchStatus = [this.interviewStatus])
                toolkit.post("/interview/excel/exportNew", params).then(res => {
                    let dataUrl = res.data.base64FileContent
                    let name = res.data.fileName
                    FileJs.download(dataUrl, name)
                })
            },
            // 多人面试增加成员
            addMember(role){
                if(this.candidateMemberList.length + this.interviewerMemberList.length == 6){
                    return this.$message.error("暂不支持6人以上的多人面试哦")
                }
                if(role == CANDIDATE_ROLE){
                    this.candidateMemberList.push({
                        role: role,
                        showName: '',
                        phone: '',
                        email: ''
                    })
                }else {
                    this.interviewerMemberList.push({
                        role: role,
                        showName: '',
                        phone: '',
                        email: ''
                    })
                }
            },
            delMember(role, index){
                if(role == CANDIDATE_ROLE){
                    this.candidateMemberList.splice(index, 1)
                }else {
                    this.interviewerMemberList.splice(index, 1)
                }
            }
        }
    }
</script>
<style scoped lang="scss">
.btn-text {
    font-size: 13px;
    font-weight: normal;
    color: #5272FF;
    margin-right: 20px;
    cursor: pointer;
}
>>>.el-table td {
    vertical-align: top;
}
>>>.el-table--group::after, .el-table--border::after, .el-table::before {
    background-color: white;
}
>>>.el-table tbody tr:hover>td { 
    background-color: #fbfbff !important
}
>>>.el-form-item{
    margin-bottom: 20px !important;
}
>>>.el-table th {
    padding: 14px 0;
}
>>>.el-table td {
    padding: 20px 0;
}
>>>.el-table .cell {
    padding-left: 20px;
}
.timepicker >>> .el-form-item{
    margin-bottom: 0px !important;
}
.spe-10 >>> .el-form-item{
    margin-bottom: 10px !important;
}
>>>.el-table th, .el-table tr {
    font-weight: normal;
}
>>>.el-table .end-row {
    // background: #f9f9f9
  }
.big-title {
  font-size:16px;
  font-weight:500;
  color:rgba(43,49,58,1);
  line-height:24px;
  float: left;
//   margin-top: 6px;
}
.content {
    min-width: 1100px;
    p{
        margin: 0;
    }
    font-size: 13px;
    .bottom {
        padding: 0 50px;
        .top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            // height: 60px;
        }
        .right{
            // text-align: right;
            // padding-bottom: 20px;
            padding: 20px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;

        }
        .search{
            border-radius:4px 4px 0px 0px;
            padding: 20px 0;
            // border: 1px solid #D0D9FF;
            box-shadow:0px 0px 0px 2px rgba(246,246,246,1);
            border-bottom: 0;
            @include flexRow;
            justify-content: space-between;
            .result{
                color: #8B8F94;
                margin-right: 20px;
                @include flexRow;
            }
        }
        .el-table{
            font-size: 14px;
            min-width: 1000px;
        }
        
        .table{
            border-radius:0px 0px 4px 4px;
            // border: 1px solid #D0D9FF;
            box-shadow:0px 0px 0px 2px rgba(246,246,246,1);
            border-bottom: 0;
            .link{
                color: #5272FF;
                cursor: pointer;
                &:hover{
                    color: #627FFF;
                }
            }
            .small{
                font-size: 13px;
            }
            .info-box{
                display: flex;
                flex-direction: column;
                .single-info{
                    display: inline-flex;
                    align-items: flex-start;
                    // margin: 4px 0;
                    margin-bottom: 5px;
                    .left{
                        flex-shrink: 0;
                    }
                }
                .name-info{
                    display: flex;
                    align-items: flex-start;
                    // margin: 4px 0;
                    .left{
                        flex-shrink: 0;
                    }
                    .name{
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                    }
                }
            }
        }
    }
}
/deep/.el-table th{
  border-bottom: 1px solid #f6f6f6;
}
/deep/.el-table td{
    border-bottom: 1px solid #f6f6f6;
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}
/deep/.timepicker {
    .el-form-item__content {
        display: flex;
    }
}
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -35px;
    margin-bottom: 10px;
    .el-button {
        width: 150px;
        margin: 0 10px;
        font-size: 13px;
    }
    .cancel{
        color: #C5C7C9;
        background: #ECECED;
        border-color: transparent;
        &:hover{
            color: #3E444C;
        }
    }
}
.timepicker {
    .line {
        display: flex;
        justify-content: center;
    }
}
.right-form{
    margin-left: 90px;
}
.info{
    color: #999;
    font-size: 13px;
    margin-bottom: 20px;
    display: inline-block;
    margin-left: 90px;
    cursor: pointer;
    text-decoration: none;
    .icon{
        margin-left: 6px;
    }
}
.cancel-contents{
    .row{
        margin-bottom: 20px;
        .label{
            width: 100px;
            display: inline-block;
        }
    }
}
.del-contents{
    margin-bottom: 25px;
    font-size: 14px;
}
.exit{
    color: #FF7062;
    &.enter{
        color: #09BB07;
    }
}
.grey-word{
    font-size:13px;
    font-family:SourceHanSansCN-Regular,SourceHanSansCN;
    font-weight:400;
    color:rgba(139,143,148,1);
    line-height:20px;
}
.common-upload{
    @include flexColumn;
    align-items: flex-start !important;
    width: 100%;
    .file{
        margin-top: 10px;
        line-height: 1;
        width: 100%;
    }
}
>>>.el-table__empty-block {
  height: 174px !important;
}
</style>
<style lang="scss">
.el-checkbox{
    font-weight: normal;
}
.el-form.inline-form{
    .el-form-item{
        display: flex;
        .el-form-item__content{
            flex: 1;
        }
    }
}
.limit {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical
}
.flexRow{
    @include flexRow;
}
.el-table td, .el-table th.is-leaf,.el-table--border, .el-table--group{
  border-color: #f6f6f6; 
}
.el-table--border::after, .el-table--group::after, .el-table::before{
  background-color: #f6f6f6;
}
</style>



// WEBPACK FOOTER //
// src/content/content.vue